export default function WhySpecialistsFail() {
  const missingSkills = [
    { icon: 'ri-user-heart-line', title: 'Управлять людьми', desc: 'Понимать мотивацию, индивидуальные особенности и находить подход к каждому сотруднику' },
    { icon: 'ri-fire-line', title: 'Мотивировать', desc: 'Создавать среду, в которой люди работают с максимальной отдачей без внешнего давления' },
    { icon: 'ri-feedback-line', title: 'Давать обратную связь', desc: 'Проводить развивающие беседы, которые меняют поведение, а не вызывают обиду' },
    { icon: 'ri-message-3-line', title: 'Проводить сложные разговоры', desc: 'Обсуждать невыполнение KPI, увольнения и конфликты профессионально и этично' },
    { icon: 'ri-seedling-line', title: 'Развивать сотрудников', desc: 'Видеть потенциал, ставить развивающие задачи и выращивать преемников' },
    { icon: 'ri-share-forward-line', title: 'Делегировать', desc: 'Передавать задачи с сохранением качества и не забирать их обратно при первой ошибке' },
    { icon: 'ri-shield-flash-line', title: 'Принимать непопулярные решения', desc: 'Брать ответственность за сложные кадровые и стратегические решения' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему хорошие специалисты становятся слабыми руководителями
        </h2>
        <p className="text-lg text-gray-600 text-center mb-12 max-w-2xl mx-auto">
          Классическая ошибка бизнеса: лучшего продавца назначают начальником отдела продаж. Лучшего программиста — тимлидом. Лучшего бухгалтера — финансовым директором. Но никто не учит их управлять.
        </p>

        <div className="bg-gradient-to-br from-gray-50 to-teal-50/30 rounded-2xl p-8 md:p-12 mb-12">
          <p className="text-gray-700 leading-relaxed text-base md:text-lg mb-6">
            Большинство руководителей становятся начальниками <strong>благодаря профессионализму</strong> — глубоким техническим знаниям, выдающимся результатам как исполнителя, лояльности компании. Но профессиональные навыки и управленческие навыки — это <strong>принципиально разные компетенции</strong>.
          </p>
          <p className="text-gray-700 leading-relaxed text-base md:text-lg">
            Именно поэтому возникает огромное количество управленческих ошибок: микроменеджмент («проще сделать самому»), неумение делегировать, избегание сложных разговоров, демотивация команды, выгорание и самого руководителя, и его сотрудников. Системное <strong>обучение руководителей</strong> закрывает этот разрыв: даёт конкретные инструменты управления, которые работают в реальном бизнесе, а не только в учебниках.
          </p>
        </div>

        <h3 className="text-2xl font-bold text-gray-900 text-center mb-8">
          Но никто не учит руководителей:
        </h3>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {missingSkills.map((skill, i) => (
            <div key={i} className="bg-gray-50 p-6 rounded-xl hover:bg-teal-50 transition-colors group text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${skill.icon} text-2xl text-white`}></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2 text-sm">{skill.title}</h4>
              <p className="text-gray-600 text-xs leading-relaxed">{skill.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-block bg-teal-50 border border-teal-200 rounded-xl px-8 py-5">
            <p className="text-lg md:text-xl font-bold text-teal-800">
              Назначение на должность — это только начало. Системное развитие управленческих навыков — путь к эффективному лидерству.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}